import focusOnActiveCta from './focusOnActiveCta';
import { TinySliderInstance } from 'tiny-slider/src/tiny-slider';

const getFocusHandler = (tinySlider: TinySliderInstance) => (event: Event) => {
    event.preventDefault();
    focusOnActiveCta(tinySlider);
};

export default getFocusHandler;
